module.exports = __webpack_public_path__ + "img/3.7e0654d0.png";